import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.bereiche-liste';
import * as api from '../../../clients/displaysteuerung';

@Injectable()
export class DisplaysteuerungBereicheListeEffects {

    BereicheListe$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_BEREICHE_LISTE),
        mergeMap((x: ac.GetBereicheListeAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getBereicheListe().pipe(
                map((result: any) => {
                    return new ac.GetBereicheListeErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetBereicheListeFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.DisplaysteuerungQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.DisplaysteuerungQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.DisplaysteuerungQueryService);
        }
        return this.service;
    }
}
